import { IGatsbyImageData } from "gatsby-plugin-image";

// TODO: Separate Gatsby specific and business core types?

export const availableLocales = ["en", "fi"] as const;
export type Lang = (typeof availableLocales)[number];

/** Default language used when no language prefix is in the URL */
export const defaultLang: Lang = "en";

/**
 * Automatically generated map of URL path prefixes.
 * The defaultLang gets an empty string, others get "/{lang}"
 */
export const langPathPrefixes: Record<Lang, string> = availableLocales.reduce(
  (acc, lang) => {
    acc[lang] = lang === defaultLang ? "" : `/${lang}`;
    return acc;
  },
  {} as Record<Lang, string>,
);

/**
 * Detect language from a URL path.
 * Checks path prefixes defined in langPathPrefixes.
 * Falls back to defaultLang if no match is found.
 */
export function detectLangFromPath(path: string): Lang {
  // Check each non-default language's prefix
  for (const lang of availableLocales) {
    const prefix = langPathPrefixes[lang];
    if (prefix && (path.startsWith(`${prefix}/`) || path === prefix)) {
      return lang;
    }
  }
  return defaultLang;
}

export const langLocalNameMap: { [key in Lang]: string } = {
  fi: "Suomi",
  en: "English",
};

export const LENGTH_UNITS = ["mm", "in"] as const;
export type LengthUnit = (typeof LENGTH_UNITS)[number];

export type Orientation = "portrait" | "landscape";

export interface Frontmatter {
  slug: string;
  date: string;
  updated: string;
  title: string;
  description: string;
  lang: string;
  category: string;
  featuredPriority: number;
  id: number; // Used to identify the same article in different languages
  showToc: boolean; // Show table of contents
  showCta: boolean; // Show CTA banner
  showRelatedArticles: boolean | null; // Show "read next" section. Defaults to true when unset.
  image: {
    childImageSharp: {
      gatsbyImageData: IGatsbyImageData;
      fluid: {
        aspectRatio: number;
        base64: string;
        sizes: string;
        src: string;
        srcSet: string;
      };
    };
  };
}

export type MarkdownRemarkNode = {
  id: string;
  excerpt: string;
  html: string;
  fields: {
    readingTimeMinutes: number;
  };
  frontmatter: Frontmatter;
};

export interface Edge {
  node: MarkdownRemarkNode;
}
